<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 16:45:51
 * @LastEditTime: 2019-08-22 10:22:47
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <div class="pageTitle">可查看调拨记录，如需调拨出货请登录经销商后台手机端。</div>

    <div class="btnBox">
      <el-button type="primary" @click="showLink=!showLink">手机端登陆地址</el-button>
    </div>
    <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
      <el-form-item label="时间:" style="text-align: center">
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="开始时间"
            v-model="form.start_time"
            style="width: 100%;"
            clearable
          ></el-date-picker>
        </el-col>
        <el-col :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="结束时间"
            v-model="form.end_time"
            style="width: 100%;"
            clearable
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="调拨单号:">
        <el-input v-model="form.stock_out_sn" clearable></el-input>
      </el-form-item>
      <el-form-item label="关键词:">
        <el-input v-model="form.keywords" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="经销商:">
                 <el-col :span="12">
                    <el-input v-model="form.to_sn" clearable></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 10px;">
                    <el-button type="primary" @click="selectType()">选择</el-button>
                </el-col>
      </el-form-item>-->

      <el-form-item label="状态:">
        <el-select v-model="form.status" clearable placeholder="请选择">
          <el-option key='-1' label="全部" value='-1'></el-option>
          <el-option key="0" label="未发货" value="0"></el-option>
          <el-option key="1" label="已发货" value="1"></el-option>
          <el-option key="2" label="部分发货" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch()" class="mr-10">搜索</el-button>
        <el-button @click="exportData()">导出</el-button>
      </el-form-item>
    </el-form>
    <!--表格-->
    <!-- <div class="tableBox" v-loading="loading">
            <table class="table table-striped table-bordered table-hover">
                <thead>
                <tr>
                    <th style="width: 40px;">序号</th>
                    <th style="width: 140px">发货单号</th>
                    <th style="width: 120px">日期</th>
                    <th style="width: 240px">经销商/门店编号</th>
                    <th style="width: 220px">经销商/门店名称</th>
                    <th style="width: 120px">是否赠品</th>
                    <th style="width: 120px">应发数量</th>
                    <th style="width: 120px">实发数量</th>
                    <th style="width: 120px">生产批次号</th>
                    <th style="width: 160px">批号应发数量</th>
                    <th style="width: 160px">批号实发数量</th>
                    <th style="width: 160px">产品编号</th>
                    <th style="width: 180px">产品名称</th>
                    <th style="width: 120px">产品规格</th>
                    <th style="width: 120px">单位</th>
                    <th style="width: 120px">发货仓库</th>
                    <th style="width: 180px">生产日期</th>
                    <th style="width: 180px">有效期至</th>
                    <th style="width: 100px;">状态</th>
                    <th style="width: 180px">收货地址</th>
                    <th style="width: 200px;">操作</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(item,index) in tableData">
                    <template v-for="(val,num) in item.outwarehouse_products">
                        <tr>
                            <template v-if="item.outwarehouse_products.length > 0 && num > 0">
                                <td colspan="8"></td>
                            </template>
                            <template v-else>
                                <td style="white-space: nowrap;">{{item.id}}</td>
                                <td style="white-space: nowrap;">{{item.stock_out_sn}}</td>
                                <td style="white-space: nowrap;">{{item.stock_out_time}}</td>
                                <td style="white-space: nowrap;">{{item.to_sn}}</td>
                                <td style="white-space: nowrap;">{{item.to_name}}</td>
                                <td>
                                    <span v-if="item.isgift == 1">赠品</span>
                                    <span v-else>非赠品</span>
                                </td>
                                <td style="white-space: nowrap;">{{item.stock_out_num}}</td>
                                <td style="white-space: nowrap;">
                                    <span @click="deliverDetail(item)" style="color:red;cursor: pointer;">
                                        {{item.real_stock_out_num}}
                                    </span>
                                </td>

                            </template>
                            <td style="white-space: nowrap;">{{val.production_batch}}</td>
                            <td style="white-space: nowrap;">{{val.stock_out_num}}</td>
                            <td style="white-space: nowrap;">{{val.real_stock_out_num}}</td>
                            <td style="white-space: nowrap;">{{val.product_sn}}</td>
                            <td style="white-space: nowrap;">{{val.product_name}}</td>
                            <td style="white-space: nowrap;">{{val.product_specs}}</td>
                            <td style="white-space: nowrap;">{{val.product_unit}}</td>
                            <td style="white-space: nowrap;">{{val.warehouse_sn}}</td>
                            <td style="white-space: nowrap;">{{val.production_date}}</td>
                            <td style="white-space: nowrap;">{{val.expiring_date}}</td>
                            <td style="white-space: nowrap;">
                                <span v-if="val.status == 0">未发货</span>
                                <span v-if="val.status == 1">已发货</span>
                                <span v-if="val.status == 2">部分发货</span>
                            </td>
                            <td style="white-space: nowrap;">{{item.to_address}}</td>
                            <td style="white-space: nowrap;">
                                <el-button type="text" size="small" @click="print(item)">打印</el-button>
                                <el-button type="text" size="small" @click="edit(item)">编辑</el-button>
                                <el-button type="text" size="small" @click="del(item)">删除</el-button>
                            </td>
                        </tr>
                    </template>
                </template>

                </tbody>
            </table>
    </div>-->

    <el-table
      :data="tableData1"
      style="width: 100%"
      border
      stripe
      v-loading="loading"
    >
      <el-table-column prop label="序号" fixed>
        <template slot-scope="scope">{{scope.$index}}</template>
      </el-table-column>
      <el-table-column prop="stock_out_sn" label="调拨单号"></el-table-column>
      <el-table-column prop="to_sn" label="调入经销商编号"></el-table-column>
      <el-table-column prop="to_name" label="调入经销商名称"></el-table-column>
      <el-table-column prop="to_person" label="负责人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="to_address" label="收货地址"></el-table-column>
      <el-table-column prop="real_stock_out_num" label="产品数量"></el-table-column>
      <el-table-column fixed="right" prop="status" label="状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.status==0">待发货</span>
          <span v-if="scope.row.status==2">发货中</span>
          <span v-if="scope.row.status==1">发货完成</span>
        </template>
      </el-table-column>
      <el-table-column  prop="created_at" label="时间"  show-overflow-tooltip></el-table-column>
      <el-table-column prop label="操作" width="180"  show-overflow-tooltip fixed="right">
        <template slot-scope="scope">

          <el-button type="text" size="small" @click="getDetail(scope.row)" v-if='scope.row.status==1'>调拨明细</el-button>
          <el-button type="text" size="small" @click="getOrder(scope.row)" >订单详情</el-button>

        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
    ></el-pagination>
    <selectDealer
      v-if="selectDealerDialog"
      v-on:handleClose="selectDealerDialog = false"
      @pushData="getSelectinfo"
    ></selectDealer>
    <!--批量导入-->
    <importData
      v-if="importDataDialog"
      v-on:handleClose="importDataDialog = false"
      @refresh="onSearch"
    ></importData>
    <!--物流码明细-->
    <deliverCodeDialog
      v-if="deliverCodeDialog"
      v-on:handleClose="deliverCodeDialog = false"
      :stock_out_sn="stock_out_sn"
    ></deliverCodeDialog>
    <copyLinkDialog @handleClose="closeLink" v-if="showLink" />
                  <el-dialog
                :visible.sync="detail"
                width="50%"
                title='调拨明细'
                >
                      <el-button  size="small" @click="exportDetail()" style='margin-bottom:10px;'>导出明细</el-button>
            <el-table
                  :data="tableData2"
                  style="width: 100%"
                  border
                  stripe
                    v-loading="loading"
                 >
              
                          <el-table-column
                                  prop="stock_out_sn"
                                  label="调拨单号"
                                  >
                          </el-table-column>
                          <el-table-column
                                  prop="created_at"
                                  show-overflow-tooltip
                                  label="时间"
                                >
                          </el-table-column>
                             <el-table-column
                                  prop="product_sn"
                                  label="产品编号"
                                 
                                 >
                          </el-table-column>
                          <el-table-column
                                  prop="product_name"
                                  label="产品名称"
                                 
                                 >
                          </el-table-column>
                          <el-table-column
                                  prop="product_specs"
                                  label="产品规格"
                                  show-overflow-tooltip>
                          </el-table-column>
                          <el-table-column
                                  prop="real_stock_out_num"
                                  label="出货数量"
                                  >
                          </el-table-column>
                          <el-table-column
                                  prop="logistics_code"
                                  label="物流码"
                                 >
                          </el-table-column>
                          <el-table-column
                                  prop="code_type"
                                  label="标签类型"
                          fixed="right"

                                 >
                          </el-table-column>
                        
                    </el-table>
                                   <!--分页-->
                <!-- <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page="pageNo2"
                        :page-sizes="[5, 10, 20, 50]"
                        :page-size="pageSize2"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize2">
                </el-pagination> -->
                    </el-dialog>
                           <el-dialog
                :visible.sync="order"
                width="50%"
                title='订单详情'
                >
            <el-table
                  :data="tableData3"
                  style="width: 100%"
                  border
                  stripe
                    v-loading="loading"
                 >
                             <el-table-column
                                  prop="product_sn"
                                  label="产品编号"
                                 
                                 >
                          </el-table-column>
                          <el-table-column
                                  prop="product_name"
                                  label="产品名称"
                                 
                                 >
                          </el-table-column>
                          <el-table-column
                                  prop="product_specs"
                                  label="产品规格"
                                  show-overflow-tooltip>
                          </el-table-column>
                          <el-table-column
                                  prop="stock_out_num"
                                  label="订单数量"
                                  >
                          </el-table-column>
                          <el-table-column
                                  prop="real_stock_out_num"
                                  label="已出货数量"
                                 >
                          </el-table-column>                        
                    </el-table>
                    </el-dialog>
                    
                    
  </div>
</template>

<script>
import selectDealer from "@/common/selectDealer";
import copyLinkDialog from "@/common/copyLinkDialog";

// import importData from './importData';
// import deliverCodeDialog from './deliverCode';

export default {
  name: "deliver-manage",
  data() {
    return {
        detail:false,
        order:false,
      loading: false,
      selectDealerDialog: false,
      importDataDialog: false,
      deliverCodeDialog: false,
      form: {
        stock_out_sn:"",
        status:"",
        keywords:"",
     
      },
      stockArray: [], //仓库
      tableData: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],

      //分页
      pageNo: 1,
      pageSize: 20,
      totalSize: 0,
      stock_out_sn: "", //传给物流明细
      showLink: false //'登陆地址弹窗'
    };
  },
  methods: {
    getLastMonth() {
      var now = new Date();
      var year = now.getFullYear(); //getYear()+1900=getFullYear()
      var month = now.getMonth() + 1; //0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
      if (preSize < parseInt(day)) {
        //上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + "-" + month + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    getOrder(data){
         this.loading=true
           this.order=true
           this.$get('logistics_1','/allocation/'+data.stock_out_sn+'/order').then(res=>{
               this.tableData3=res.product_data
                this.loading=false
           })
    },
      getDetail(data){
                    this.loading=true
                    this.detail=true
                    this.detailData=data
                    this.$get('logistics_1','/allocation/'+data.stock_out_sn+'/productdata',{
                        is_export:0
                    }).then(res=>{
                        this.tableData2=res.data
                          this.loading=false
                    })
                },
                      //导出
                exportDetail() {
                    let url = '',access_tokens = localStorage.getItem('access_token');
             

                    window.open(process.env.VUE_APP_URL_V1
                        +'/allocation/'+this.detailData.stock_out_sn+'/productdata.export? '+
                       '&lang=' + '' +'&is_export=1'+
                       +'&signature='+ this.$md5(access_tokens)

                    )
                },
    //获取选择经销商门店
    getSelectinfo(val) {
      if (val.dealer_sn) {
        this.form.to_sn = val.dealer_sn;
        this.form.to_type = 2;
      } else {
        this.form.to_sn = val.shop_sn;
        this.form.to_type = 3;
      }
    },
    //请求列表数据
    onSearch() {
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        this.form.start_time = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        this.form.end_time = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      this.loading = true;
      this.$get("logistics_1", "/allocation", {
        lang: "",
        ...this.form,
        per_page: this.pageSize,
        page: this.pageNo,
        channel :1,
        is_export :0
      })
        .then(res => {
          this.loading = false;
          this.tableData1 = res.data;
          this.totalSize = res.meta.total;
        })
        .catch(function(error) {
          this.loading = false;
          console.log(error);
        });
    },

    //选择经销商/门店
    selectType() {
      this.selectDealerDialog = true;
    },
    //导出
    exportData() {
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      let url = "",
        access_tokens = localStorage.getItem("access_token");
  

      window.open(
          process.env.VUE_APP_URL_V1 +
          "/allocation.export?start_time=" +
          beginstr +
          "&end_time=" +
          endstr +
          "&channel=1" +
          "&is_export=1" +
          "&stock_out_sn=" +
          this.form.stock_out_sn +
          "&keywords=" +
          this.form.keywords +
          "&lang=" +
          "" +
          "&status=" +
          this.form.status +
          "&signature=" +
          this.$md5(access_tokens)
      );
    },
    //发货标签码明细
    deliverDetail(row) {
      this.stock_out_sn = row.stock_out_sn;
      this.deliverCodeDialog = true;
    },
    //打印
    print(item) {
      this.$router.push({
        name: "printDeliver",
        query: {
          stock_out_sn: item.stock_out_sn
        }
      });
    },
    //编辑
    edit(item) {
      this.$router.push({
        name: "addDeliver",
        query: {
          stock_out_sn: item.stock_out_sn
        }
      });
    },
    //删除
    del(item) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let url = "/outwarehouses/" + item.stock_out_sn;
          this.$delete("logistics", url, {})
            .then(res => {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.onSearch();
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: error.message
              });
            });
        })
        .catch(error => {
          this.$message({
            type: "error",
            message: error.message
          });
        });
    },
    /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.onSearch();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.onSearch();
    },
    // 关闭 登陆地址弹窗
    closeLink() {
      this.showLink = !this.showLink;
    }
  },
  created() {
    this.form.start_time = this.getLastMonth().last;
    this.form.end_time = this.getLastMonth().now;
    // this.getStock();
    this.onSearch();
  },
  components: {
    // , importData, deliverCodeDialog
    selectDealer,
    copyLinkDialog
  }
};
</script>
<style lang="scss" scoped>
// .tableBox {
//     overflow-x: scroll;
//     .table {
//         width: 300%;
//     }
// }
</style>